import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import { datePickerInputClassName } from '../../utils/Utils';

export default function DateFilterInput({
    label,
    disabled,
    selected,
    onChange,
}: {
    label: string;
    disabled?: boolean;
    selected: Date | undefined;
    onChange: (date: Date | undefined) => void;
}) {
    return (
        <div>
            <div className="text-sm font-medium text-label pb-1.5">{label}</div>
            <div className="relative">
                <DatePicker
                    dateFormat="yyyy-MM-dd"
                    disabled={disabled}
                    selected={selected}
                    onChange={(date: Date) => onChange(date)}
                    className={`${datePickerInputClassName}${selected ? ' pr-9' : ''}`}
                />
                {selected && (
                    <button
                        type="button"
                        onClick={() => onChange(undefined)}
                        aria-label={`Clear ${label}`}
                        className="absolute inset-y-0 right-0 flex items-center justify-center w-9 text-foreground-muted hover:text-foreground transition-colors focus:outline-none"
                    >
                        <svg
                            className="w-4 h-4"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    );
}
